import { render, staticRenderFns } from "./ym-overage.vue?vue&type=template&id=ee70ae34&scoped=true&"
import script from "./ym-overage.vue?vue&type=script&lang=js&"
export * from "./ym-overage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee70ae34",
  null
  
)

export default component.exports